import axios from 'axios';
import store from '@/store';
import endpointVersion from '@/helpers/endpoint-version';
export const getRfvMetrics = () => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    const startDate = store.getters.dates.startDate;
    const endDate = store.getters.dates.endDate;
    return axios({
        headers: { Authorization: `Bearer ${tokenV3}` },
        method: 'GET',
        baseURL: endpointVersion('v3'),
        url: '/o2o/getMetricsRfv',
        params: {
            brand: brand.id,
            startDate,
            endDate,
        },
    });
};
export const getTableSegmentMatrix = () => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    const startDate = store.getters.dates.startDate;
    const endDate = store.getters.dates.endDate;
    return axios({
        headers: { Authorization: `Bearer ${tokenV3}` },
        method: 'GET',
        baseURL: endpointVersion('v3'),
        url: '/o2o/getTableSegmentMatrix',
        params: {
            brand: brand.id,
            startDate,
            endDate,
        },
    });
};
